module.exports = __webpack_public_path__ + "img/上海高容百度地图.42e2faf4.png";